// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","imageCol":"_20Lc","title":"_2zul","item":"BXR2","icon":"_2oaN"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextList/MultiTextList.scss
// module id = Hl+H
// module chunks = 0